import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import { Link, LinkProps } from '../../link/link'
import {
  StyledLinkItemText,
  StyledListItem,
  StyledListItemGrid,
  StyledListItemUtilityGrid,
  StyledTextSpan
} from './styledMobileMenuItem'

export type MobileMenuUtilityItemProps = React.ComponentProps<typeof StyledListItem> & Pick<LinkProps, 'href'> & {
  icon: ReactNode
  children: string
  setClosed?: () => void
  target?: boolean
}

export const StyledIconContainer = styled.div`
  margin-right: ${props => props.theme.typography.pxToRem(10)};
  margin-bottom: ${props => props.theme.typography.pxToRem(10)};
  flex-direction: row;
  align-items: baseline;
  display: flex;
`

export const MobileMenuUtilityItem: React.FC<PropsWithChildren<MobileMenuUtilityItemProps>> = ({ setClosed, onClose, href, target, icon, children, ...props }) => {
  return (
    <Link target={target ? '_blank' : '_self'} href={href}>
      <StyledListItem $isLink={true} onClick={setClosed} $utility={true} {...props}>
        <StyledListItemUtilityGrid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Grid item>
            <StyledTextSpan>
              <StyledLinkItemText $isUtility>
                {children}
              </StyledLinkItemText>
              <StyledIconContainer>
                {icon}
              </StyledIconContainer>
            </StyledTextSpan>
          </Grid>
        </StyledListItemUtilityGrid>
      </StyledListItem>
    </Link>
  )
}
